module.exports = {"371482001":"市中街道","371482002":"禹兴街道","371482100":"伦镇","371482101":"房寺镇","371482102":"张庄镇","371482103":"辛店镇","371482104":"安仁镇","371482105":"辛寨镇","371482106":"梁家镇","371482107":"十里望回族镇","371482108":"莒镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/371482.json
// module id = 1602
// module chunks = 0